import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// COMPONENTS
import FormsDeliveryAddressPersonal from 'components/Forms/FormsDeliveryAddressPersonal';
import FormsPersonalData from 'components/Forms/FormsPersonalData';
import FormsCompanyData from 'components/Forms/FormsCompanyData';

// DS
import {
  VertContainer,
  Col,
  Row,
  VertButton,
  VertAlert,
} from '@vertem-core/vertice-ds';

// SERVICES
import PipeProvider from 'Services/Providers/PipeProvider';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';

// STYLES
import 'Assets/styles/default/pages/profile/ProfileStyles.less';

// UTILS
import { isObjectEmpty } from 'Utils';
import generateUUID from 'Utils/generateUUID';
import { handleObjectAddress } from 'Utils/handleObjectAddress';
import { genderTypes, profileStatuses } from './models';
import moment from 'moment';
import ToastErrorAlert from 'components/ToastAlert/ToastErrorAlert';
import { useNavigate } from 'react-router';
import ynToBool from 'Utils/ynToBool';
import { GetValidateIe } from 'redux/Reducers/StateInscription/StateInscriptionReducer';
import { isEmpty } from 'lodash';

const type = { value: undefined, disabled: undefined };
const initFormData = {
  name: type,
  companyName: type,
  documentNumber: type,
  maritalStatus: type,
  genderType: type,
  birthDate: type,
  email: type,
  phone: type,
  stateInscription: type,
  partnerCpf: type,
};
const initFormAddress = {
  name: type,
  street: type,
  number: type,
  reference: type,
  complement: type,
  district: type,
  city: type,
  state: type,
  zipCode: type,
};

export const getOnlyNumbers = (v) => {
  let value = v
  if (typeof v === 'number') value = v.toString()
  const numberPattern = /\d+/g;
  return value.match(numberPattern).join([]);
};

// PROFILE PAGE
const ProfilePage = () => {
  const { callApi } = usePipeContext();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Participants = useSelector(({ Participants: data }) => data);

  const Cart = useSelector(({ Cart: data }) => data);
  const Shipping = useSelector(({ Shipping: data }) => data);
  const [stateInscriptionSaved, setStateInscriptionSaved] = React.useState();
  const clientHasIEValidation = ynToBool(
    process.env.REACT_APP_HAS_IE_VALIDATION_PROFILE
  );

  const {
    stateInscriptionIsLoading,
    stateInscriptionData,
    stateInscriptionError,

    stateInscriptionFullfiled,
  } = useSelector((state) => state.ValidateIe);

  const [isLoading, setIsloading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [formAddress, setFormAddress] = useState({ ...initFormAddress });
  const [formData, setFormData] = useState({ ...initFormData });
  const [hasProfileError, setHasProfileError] = useState(false);
  const [payload, setPayload] = useState({});
  const [addressPayload, setAddressPayload] = useState({});
  const [validPersonal, setValidPersonal] = useState(false);
  const [validCompany, setValidCompany] = useState(false);
  const [validAddress, setValidAddress] = useState(false);
  const [validaEndereco, setValidaEndereco] = useState(true);
  const buildPhone = (phone, type) => {
    if (!phone) {
      return { areaCode: '', number: '', type };
    }

    const onlyNumbers = getOnlyNumbers(phone);
    return {
      areaCode: onlyNumbers.substr(0, 2),
      number: onlyNumbers.substr(2),
      type,
    };
  };

  const isvalid = (validPersonal || validCompany) && validAddress;

  const fetchData = (symbol, payload = null) => {
    const alias = generateUUID();
    callApi({
      symbol,
      alias,
      payload,
    });
  };

  const hasError = () => {
    if (Participants?.hasError && !isObjectEmpty(Participants?.error)) {
      setHasProfileError(true);
      return true;
    }
    if (Cart?.hasError && !isObjectEmpty(Cart?.error)) {
      setHasProfileError(true);
      return true;
    }
    setHasProfileError(false);
    return false;
  };

  const handleFormValid = (value) => {
    if (
      value &&
      (value.hasOwnProperty('personalData') ||
        value.hasOwnProperty('companyData'))
    ) {
      setValidPersonal(value?.personalData);
    }
    if (value && value.hasOwnProperty('companyData')) {
      setValidCompany(value?.companyData);
    }
    if (value && value.hasOwnProperty('deliveryAddress')) {
      setValidAddress(value?.deliveryAddress);
    }
  };

  const saveChange = () => {
    if (stateInscriptionIsLoading) return;

    const {
      birthDate,
      companyName,
      documentNumber,
      email,
      partnerCpf,
      name,
      phone,
      stateInscription,
      maritalStatus,
    } = formData;
    const { profileId, statusId, phonesDefault, emailsDefault } = Participants;

    let arrayEmail = emailsDefault;
    let emailCurrent = arrayEmail.some(
      (item) => item.email === email.value && item.type === 'PERSONAL'
    );
    if (!emailCurrent) {
      arrayEmail = arrayEmail.filter((item) => item.type !== 'PERSONAL');
      arrayEmail.push({ email: email.value, type: 'PERSONAL' });
    }

    let arrayPhone = phonesDefault;
    let phoneCurrent = arrayPhone.some(
      (item) =>
        `${item.areaCode}${item.number}` === phone.value &&
        item.type === 'MOBILE'
    );
    if (!phoneCurrent) {
      arrayPhone = [];
      arrayPhone.push(buildPhone(phone.value, 'MOBILE'));
      arrayPhone.push(buildPhone(phone.value, 'HOME'));
      arrayPhone.push(buildPhone(phone.value, 'WORK'));
    }

    const number = formAddress.number.value == "S/N" ? 0 : formAddress.number.value;

    let complementValue = formAddress.complement.value?.trim();
    
    const addressData = {
      street: formAddress.street.value,
      number,
      complement: isEmpty(complementValue) ? 'Nenhum' : formAddress.complement.value,
      district: formAddress.district.value,
      city: formAddress.city.value,
      state: formAddress.state.value ? formAddress.state.value : 'SP',
      zipCode: getOnlyNumbers(formAddress.zipCode.value)
        ? getOnlyNumbers(formAddress.zipCode.value)
        : '00000000',
      reference: 'Nenhum',
    };

    let payloadData = {};

    if (Participants.personType === 1) {
      payloadData = {
        birthDate: moment(birthDate.value, 'DD/MM/YYYY').format(),
        documentNumber: getOnlyNumbers(documentNumber.value),
        emails: arrayEmail,
        genderType: genderTypes[3],
        maritalStatus: maritalStatus.value,
        name: name.value,
        phones: arrayPhone,
        profileId,
        stateInscription: stateInscription.value ?? 'ISENTO',
        status: profileStatuses[statusId],
        personType: 'INDIVIDUAL',
      };
    } else {
      let invalidBirthDate =
        birthDate.value === '' ||
        birthDate.value === undefined ||
        birthDate.value === null;

      payloadData = {
        birthDate: invalidBirthDate
          ? null
          : moment(birthDate.value, 'DD/MM/YYYY').format(),
        companyName: companyName.value,
        documentNumber: getOnlyNumbers(documentNumber.value),
        emails: arrayEmail,
        genderType: genderTypes[3],
        maritalStatus: maritalStatus.value,
        name: name.value,
        partnerCpf: getOnlyNumbers(partnerCpf.value),
        phones: arrayPhone,
        profileId,
        stateInscription: stateInscription.value ?? 'ISENTO',
        status: profileStatuses[statusId],
        personType: 'COMPANY',
      };
    }

    setPayload(payloadData);
    setAddressPayload(addressData);
    fetchData('UPDATE_PARTICIPANT', {
      ...payloadData,
      address: addressData,
    });
  };

  useEffect(() => {
    if (Cart.cartFinishRequests) {
      fetchData('FETCH_CART');
    }

    const addressData = handleObjectAddress(Cart, Participants);
    setFormAddress({ ...addressData });

    const data = {
      name: Participants.name,
      companyName: Participants.companyName,
      documentNumber: Participants.cpfCnpj,
      maritalStatus: Participants.maritalStatus,
      genderType: Participants.genderType,
      birthDate: Participants.birthDate,
      email: Participants.email,
      phone: {
        value: `${Participants.phones.mobile.areaCode}${Participants.phones.mobile.number}`,
        disabled: Participants.phones.mobile.disabled,
      },
      stateInscription: Participants.ie,
      partnerCpf: Participants.partnerCpf,
    };
    setFormData({ ...data });
  }, []);

  useEffect(() => {
    if (Participants.updatedSuccessfully) {
      fetchData('UPDATE_CART_SHIPPING', {
        customer: { ...payload, email: formData.email.value },
        shippingAddress: addressPayload,
      });
      setIsComplete(true);
    }
  }, [Participants?.updatedSuccessfully]);

  useEffect(() => {
    if (Shipping?.updatedSuccessfully && isComplete) {
      setIsComplete(false);
      fetchData('FETCH_PARTICIPANT');
      fetchData('FETCH_CART');
      navigate('/cart');
    }
  }, [Shipping?.updatedSuccessfully]);

  useEffect(() => {
    hasError();
  }, [Participants?.isUpdating]);

  useEffect(() => {
    if (Participants?.isUpdating || Cart?.isUpdating) {
      setIsloading(true);
    } else if (!Participants?.isUpdating && !Cart?.isUpdating) {
      setIsloading(false);
    }
  }, [Participants?.isUpdating, Cart?.isUpdating]);

  useEffect(() => {
    if (Participants?.finishRequests) {
      if (
        !Participants.ie.value &&
        Participants.address.zipCode.value != '00000000'
      )
        validateIe(Participants.address.state.value);
    }
  }, [Participants?.finishRequests]);

  useEffect(() => {
    if (stateInscriptionFullfiled) {
      if (!stateInscriptionError) {
        const stateInscriptionString = stateInscriptionData.toString();

        setFormData({
          ...formData,
          stateInscription: {
            value: `${stateInscriptionString}`,
            disabled: false,
          },
        });
        setStateInscriptionSaved(stateInscriptionString);
      }
    }
  }, [stateInscriptionFullfiled]);

  const onBlurValidateIe = (value) => {
    if (!formAddress.state.value) return;

    if (
      !stateInscriptionSaved ||
      !value ||
      (value && stateInscriptionSaved && value != stateInscriptionSaved)
    ) {
      validateIe(formAddress.state.value);
    }
  };

  const validateIe = (uf) => {
    if (clientHasIEValidation) {
      let payload = { document: Participants.cpfCnpj.value, uf };
      dispatch(GetValidateIe(payload));
    }
  };

  const changeAddressHandle = (name, value) => {
    setFormAddress({
      ...formAddress,
      [name]: { value },
    });

    if (name == 'state') {
      validateIe(value);
    }
  };

  const changePersonalDataHandle = (name, value) => {
    setFormData({
      ...formData,
      [name]: { value },
    });
  };

  const alertWarningProfileText = process.env.REACT_APP_ALERT_WARNING_PROFILE_TEXT;

  return (
    <PipeProvider apiSymbols={['FETCH_CART', 'FETCH_PARTICIPANT']}>
      <VertContainer className="profile-page-wrapper">
        {alertWarningProfileText && (
            <VertAlert
              type="warning"
            
              style={{ marginBottom: 'var(--spacing-regular)' }} 
              message={
                <>
                {alertWarningProfileText}
                {
                  process.env.REACT_APP_EXTERNAL_URL_DISCLAIMER  && <a href={process.env.REACT_APP_EXTERNAL_URL_DISCLAIMER} target="_blank">{` Clique aqui e vá para Meu Cadastro`}</a>
                }
                </>
              }
              closable={false}
            />
        )}
        <Col className="profile-page-content">
          {hasProfileError && (
            <>
              <ToastErrorAlert
                error={Cart?.error || Participants?.error}
                className={`margin-bottom-small`}
              />
            </>
          )}
        </Col>

        <Col className="profile-page-content">
          {Participants.personType === 1 ? (
            <FormsPersonalData
              form={formData}
              stateInscriptionIsLoading={stateInscriptionIsLoading}
              clientHasIEValidation={clientHasIEValidation}
              onChange={(name, value) => {
                changePersonalDataHandle(name, value);
              }}
              validateIeEmitter={(value) => {
                onBlurValidateIe(value);
              }}
              isValid={handleFormValid}
            />
          ) : (
            <FormsCompanyData
              form={{ ...formData }}
              stateInscriptionIsLoading={stateInscriptionIsLoading}
              clientHasIEValidation={clientHasIEValidation}
              onChange={(name, value) =>
                setFormData({
                  ...formData,
                  [name]: { value },
                })
              }
              validateIeEmitter={(value) => {
                onBlurValidateIe(value);
              }}
              isValid={handleFormValid}
            />
          )}

          <FormsDeliveryAddressPersonal
            form={{ ...formAddress }}
            setFormAddress={setFormAddress}
            onChange={(name, value) => changeAddressHandle(name, value)}
            validateIE={(value) => validateIe(value)}
            isValid={handleFormValid}
            validaEndereco={validaEndereco}
            setValidaEndereco={setValidaEndereco}
          />
          <Row>
            <Col className="profile-page-button">
              <VertButton
                onClick={() => {
                  saveChange();
                }}
                type="highlight"
                disabled={!isvalid || isLoading || stateInscriptionIsLoading}
                loading={isLoading}
              >
                Salvar Dados
              </VertButton>
            </Col>
          </Row>
        </Col>
      </VertContainer>
    </PipeProvider>
  );
};

export default ProfilePage;